import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    public baseUri: string;


    constructor(private httpClient: HttpClient) { }

    setUrlPathApi(baseUri: string) {
        if (environment.production) {
            this.baseUri = environment.serviceUrl + baseUri
        } else {
            this.baseUri = environment.serviceUrl + baseUri
        }
    }

    setUrlPathAdjuntos(baseUri: string) {
        if (environment.production) {
            this.baseUri = environment.serviceUrl_Adjuntos + baseUri
        } else {
            this.baseUri = environment.serviceUrl_Adjuntos + baseUri
        }
    }
    
    setUrlPathReportes(baseUri: string) {
        if (environment.production) {
            this.baseUri = environment.serviceUrl_Report + baseUri
        } else {
            this.baseUri = environment.serviceUrl_Report + baseUri
        }
    }

    setUrlPathLogin(baseUri: string) {
        if (environment.production) {
            this.baseUri = environment.serviceUrlLogin + baseUri
        } else {
            this.baseUri = environment.serviceUrlLogin + baseUri
        }
    }
    setUrlPathApiReport(baseUri: string) {
        if (environment.production) {
            this.baseUri = environment.serviceUrl_Report + baseUri
        } else {
            this.baseUri = environment.serviceUrl_Report + baseUri
        }
    }
    executePostJson(data: any): Observable<any> {
        return this.httpClient.post(this.baseUri, data, { observe: 'response' },)
    }

    executePostQueryParam(queryParams: string): Observable<any> {
        const URL = `${this.baseUri}${queryParams}`
        return this.httpClient.post(URL,{ observe: 'response' },)
    }

    executePutJson(data: any): Observable<any> {
        return this.httpClient.put(this.baseUri, data, { observe: 'response' })
    }

    executePutQueryParam(queryParams: string) {
        const URL = `${this.baseUri}${queryParams}`
        return this.httpClient.put(URL, { observe: 'response' })
    }

    executeDeleteJson(queryParams: any): Observable<any> {
        const URL = `${this.baseUri}${queryParams}`
        return this.httpClient.delete(URL)
    }

    execGetJson() {
        const URL = this.baseUri
        return this.httpClient.get(URL, { observe: 'response' })
    }

    //Metodo para ejecutar servicios con queryParams
    execGetQueryJson(queryParams: string) {
        const URL = `${this.baseUri}${queryParams}`
        return this.httpClient.get(URL, { observe: 'response' })
    }

    execGetQueryJsonPDF(queryParams: string) {
        const URL = `${this.baseUri}${queryParams}`
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.get(URL, httpOptions)
    }

    execGetQueryJsonObjectPDF(queryParams: string, object: any) {
        const URL = `${this.baseUri}${queryParams}`
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.post(URL, object, httpOptions)
    }

    execGetQueryJsonObjectPut(queryParams: string, object: any) {
        const URL = `${this.baseUri}${queryParams}`
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.put(URL, object, httpOptions)
    }

    execGetQueryJsonObjectPDF2(queryParams: string, object: any) {
        const URL = `${this.baseUri}${queryParams}`
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.get(URL, object)
    }
}